import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import CompWellnessPatient from '../Models/CompWellnessPatient';

export interface PatientState {
    patients: CompWellnessPatient[]
}

const initialState: PatientState = {
    patients: []
}

export const compWellnessPatientSlice = createSlice({
  name: "patients",
  initialState,
  reducers: {
    setCompWellnessPatients: (state, action: PayloadAction<CompWellnessPatient[]>) => {
      state.patients = action.payload
    },
    updateCompWellnessPatient: (state, action: PayloadAction<CompWellnessPatient>) => {
      var index = state.patients.findIndex(patient => patient.kitNumber === action.payload.kitNumber);
      if (index !== -1) state.patients.splice(index, 1, action.payload);
    },
    removeCompWellnessPatients: (state, action: PayloadAction<CompWellnessPatient[]>) => {
      var resultState = [...state.patients];

      action.payload.forEach(patient => {
        var index = resultState.indexOf(patient);
        if (index !== -1) resultState.splice(index, 1);
      })

      state.patients = resultState;
    },
  },
  // removed removePatients
})

// Action creators are generated for each case reducer function
export const { setCompWellnessPatients, removeCompWellnessPatients, updateCompWellnessPatient } = compWellnessPatientSlice.actions

export default compWellnessPatientSlice.reducer